import React from "react";
import { Link, NavLink } from "react-router-dom";
import { ShoppingBag, Menu, X } from "lucide-react";
import { useCart } from "@/lib/cart";

const links = [
  { to: "/shop", label: "Shop All" },
  { to: "/collections/premium-hoodies", label: "Premium" },
  { to: "/collections/performance-hoodies", label: "Performance" },
  { to: "/collections/coastal-polos", label: "Polos" },
  { to: "/collections/womens", label: "Women's" },
  { to: "/collections/premium-hats", label: "Hats" },
];

export const Navbar = () => {
  const { count, setOpen } = useCart();
  const [mobileOpen, setMobileOpen] = React.useState(false);

  return (
    <header className="sticky top-0 z-40 b2t-glass" data-testid="site-navbar">
      {/* Top accent strip */}
      <div className="bg-navy text-white text-[11px] font-medium tracking-widest text-center py-2">
        FREE SHIPPING OVER $75 · TEE OFF. TIDE OUT.
      </div>

      <nav className="max-w-7xl mx-auto px-6 md:px-10 py-4 flex items-center justify-between gap-6">
        <Link to="/" className="flex items-center gap-2 group" data-testid="nav-logo">
          <img
            src="https://customer-assets.emergentagent.com/job_nautical-polos/artifacts/8xxylszx_DC6D1D5E-BA1A-4F52-B0D9-C64358C3561C.png"
            alt="Boat 2 Tee"
            className="h-14 md:h-16 w-auto"
          />
        </Link>

        <ul className="hidden lg:flex items-center gap-7">
          {links.map((l) => (
            <li key={l.to}>
              <NavLink
                to={l.to}
                data-testid={`nav-link-${l.to.split("/").pop()}`}
                className={({ isActive }) =>
                  `text-[13px] font-semibold uppercase tracking-[0.16em] transition-colors ${
                    isActive ? "text-seafoam-600" : "text-navy hover:text-seafoam-600"
                  }`
                }
              >
                {l.label}
              </NavLink>
            </li>
          ))}
        </ul>

        <div className="flex items-center gap-3">
          <button
            type="button"
            onClick={() => setOpen(true)}
            data-testid="nav-cart-button"
            className="relative p-2 hover:bg-sand transition-colors"
            aria-label="Open cart"
          >
            <ShoppingBag className="w-5 h-5 text-navy" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-badge"
                className="absolute -top-0.5 -right-0.5 bg-coral text-white text-[10px] font-bold w-5 h-5 flex items-center justify-center"
              >
                {count}
              </span>
            )}
          </button>

          <button
            type="button"
            className="lg:hidden p-2"
            onClick={() => setMobileOpen((s) => !s)}
            data-testid="mobile-menu-toggle"
            aria-label="Toggle menu"
          >
            {mobileOpen ? <X className="w-5 h-5" /> : <Menu className="w-5 h-5" />}
          </button>
        </div>
      </nav>

      {mobileOpen && (
        <div className="lg:hidden bg-white border-t border-navy/10" data-testid="mobile-menu">
          <ul className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <li key={l.to}>
                <Link
                  to={l.to}
                  onClick={() => setMobileOpen(false)}
                  className="block py-2 text-sm font-semibold uppercase tracking-[0.16em] text-navy"
                  data-testid={`mobile-nav-link-${l.to.split("/").pop()}`}
                >
                  {l.label}
                </Link>
              </li>
            ))}
          </ul>
        </div>
      )}
    </header>
  );
};
